import { Injectable } from '@angular/core';
import { Observable, BehaviorSubject } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { environment } from '@environments/environment';
import { YpEtiketlerInfo } from '@core/models/genel/YpEtiketlerInfo';
import { SayfalamaSonuc } from '@core/models/genel/SayfalamaSonuc';

@Injectable()
export class EtiketlerService {

  constructor(private http: HttpClient) {
  }

  getData(parametersModel?: any): Observable<SayfalamaSonuc> {
    return this.http.get<SayfalamaSonuc>(environment.API_ETIKETLER_URL, { params: parametersModel });
  }
  select(id: number): Observable<YpEtiketlerInfo> {
    return this.http.get<YpEtiketlerInfo>(environment.API_ETIKETLER_URL + id.toString());
  }
  ekleGuncelle(entity: YpEtiketlerInfo): Observable<any> {
    return this.http.post<YpEtiketlerInfo>(environment.API_ETIKETLER_URL, entity);
  }
  sil(id: number, faturaEtiketleriSil: boolean): Observable<any> {
    return this.http.delete<any>(environment.API_ETIKETLER_URL + id.toString() + "/" + faturaEtiketleriSil);
  }
}